const Testimonials = () => {
  return (
    <section data-cy="testimonials">
      <div className="mb-10 text-center text-6xl font-bold">
        Real members, real stories of impact
      </div>
      <div className="flex flex-row items-center justify-center gap-10 px-10">
        <div className="h-96 w-full rounded-2xl bg-sandstone-500" />
        <div className="h-96 w-full rounded-2xl bg-sandstone-500" />
        <div className="h-96 w-full rounded-2xl bg-sandstone-500" />
      </div>
    </section>
  );
};

export default Testimonials;
